/* Data for the six SEO solution pages */
import { SOLUTIONS_ES, PROOFS_ES } from "./solutions.es";

export const SOLUTIONS = [
  {
    slug: "brokerage-launch",
    navLabel: "Brokerage Launch",
    navDesc: "End-to-end brokerage launch services",
    iconKey: "chart",
    seoTitle: "Brokerage Launch Services — Start a Forex Brokerage End to End | Ah-Jin Group",
    seoDesc: "Launch a forex / CFD brokerage end to end: incorporation, licensing support, provider negotiations, platform setup and go-live. Since 2015. LATAM, Europe, UAE.",
    eyebrow: "Brokerage Launch Services",
    buyer: "For founders launching a retail FX / CFD brokerage",
    h1a: "Launch a brokerage that's",
    h1b: "live in weeks, not quarters.",
    outcome: "We run the entire build — incorporation, licensing support, provider negotiations, agreement handling and platform setup — so you go from idea to a live, client-ready brokerage with one team accountable for the outcome.",
    waMsg: "Hi Ah-Jin Group — I want to launch a brokerage.",
    service: "All-in-One Consultation — Full Launch",
    included: [
      { t: "Incorporation & structure", d: "Entity formed in the right jurisdiction, with banking-ready corporate documents." },
      { t: "Licensing support", d: "Licence file preparation and regulator dialogue where your model requires it." },
      { t: "Provider negotiations", d: "We shortlist, negotiate and contract platform, liquidity, CRM and PSP vendors on your behalf." },
      { t: "Agreement handling", d: "Vendor agreements reviewed and coordinated so terms protect you at go-live and after." },
      { t: "Platform setup", d: "MT4 / MT5, cTrader or Match-Trader stood up, configured and connected to liquidity." },
      { t: "Go-live coordination", d: "CRM, payments and operations wired into one working whole — with a day-one runbook." },
    ],
    forWho: [
      "Founders starting their first FX / CFD brokerage",
      "IBs and fund managers converting flow into their own brand",
      "Existing firms adding a new licensed entity or region",
      "Teams that want one accountable partner, not five vendors",
    ],
    notFor: [
      "Businesses seeking regulated custody or banking licences",
      "Founders who only need hosting or a website",
      "Projects looking for capital raising or investors",
    ],
    jurisdictions: [
      { name: "Saint Lucia", note: "Fast incorporation, popular first base for new brokerages" },
      { name: "Saint Vincent (SVG)", note: "Established offshore route for early-stage brands" },
      { name: "Seychelles", note: "Securities-dealer licence path when regulation is required" },
      { name: "UAE", note: "Operational base, banking and substance" },
      { name: "Europe", note: "EU-facing structures and upgrade paths" },
    ],
    proofs: ["newera-broker", "invictus-markets"],
    faqs: [
      { q: "How long does it take to launch a brokerage?", a: "With incorporation-only structures, clients have gone live in a matter of weeks. Licensed setups depend on the regulator — typically a few months. We give you a realistic timeline for your specific model before any engagement starts." },
      { q: "How much does it cost to start a brokerage?", a: "Our full brokerage launch starts from $35,000, with incorporation-only routes from $6,500. Third-party costs (platform fees, liquidity deposits, government fees) are separate and we negotiate those on your behalf. See our pricing page for the full breakdown." },
      { q: "Do I need a licence to run a brokerage?", a: "It depends on where your clients are and how you operate. Many founders start with an incorporated offshore entity and upgrade to a licensed structure as they grow. We map the compliant route for your target markets before you commit." },
      { q: "Which platform should I choose — MT5, cTrader or Match-Trader?", a: "It depends on your budget, target region and growth plan. We're vendor-neutral: we've launched clients on all major stacks and recommend the platform that fits your model, then negotiate the terms." },
    ],
  },
  {
    slug: "prop-firm-launch",
    navLabel: "Prop Firm Launch",
    navDesc: "Structure to go-live for prop firms",
    iconKey: "trophy",
    seoTitle: "Prop Firm Launch Services — Start a Prop Trading Firm | Ah-Jin Group",
    seoDesc: "Start a prop trading firm from structure to go-live: operating model, challenge design, provider stack, compliance support and payouts. Launched firms since 2015.",
    eyebrow: "Prop Firm Launch Services",
    buyer: "For founders building a funded-trader / prop firm business",
    h1a: "Start a prop firm",
    h1b: "built to survive its first payout.",
    outcome: "From operating model to provider stack to challenge design, we set your prop firm up correctly the first time — with the technology, rules and payment flows that keep traders funded and your business protected.",
    waMsg: "Hi Ah-Jin Group — I want to launch a prop firm.",
    service: "All-in-One Consultation — Full Launch",
    included: [
      { t: "Operating model", d: "Entity structure, jurisdiction and business model designed around your challenge economics." },
      { t: "Challenge model setup", d: "Phases, targets, drawdown rules and payout logic tuned to be attractive and sustainable." },
      { t: "Provider stack", d: "Prop platform, dashboard, trading tech and data vendors selected and negotiated for you." },
      { t: "Compliance support", d: "Terms of service, risk disclosures and operational compliance via partner firms." },
      { t: "Payments & payouts", d: "PSPs and payout rails that actually work for prop firms — cards, crypto and local methods." },
      { t: "Go-live & operations", d: "Trader onboarding flow, support setup and a runbook your team can execute from day one." },
    ],
    forWho: [
      "Trading educators and communities monetising an audience",
      "Founders entering the funded-trader industry",
      "Brokers adding a prop arm to an existing business",
      "Operators relaunching after a failed white-label attempt",
    ],
    notFor: [
      "Projects that promise guaranteed trader profits",
      "Founders unwilling to fund initial payout reserves",
      "Businesses seeking investment or capital raising",
    ],
    jurisdictions: [
      { name: "Saint Lucia", note: "Common, fast base for prop-firm entities" },
      { name: "BVI", note: "Established structure for international operators" },
      { name: "UAE", note: "Operational base with strong banking options" },
      { name: "Europe", note: "EU-facing presence where your traders are" },
    ],
    proofs: ["newera-prop", "capital-flow-trader"],
    faqs: [
      { q: "How much does it cost to start a prop firm?", a: "Our prop-firm launch package starts from $18,000. Platform and dashboard vendor fees are separate — we negotiate those and typically save clients more than our fee in vendor terms alone." },
      { q: "Do prop firms need a financial licence?", a: "Most challenge-based prop firms operate without a brokerage licence because traders trade demo/simulated accounts. Regulation is evolving — we structure you conservatively and keep the upgrade path open." },
      { q: "Which prop platform should I use?", a: "We work across the major prop tech stacks (including Match-Trader's prop offering) and recommend based on your challenge design, volume expectations and budget — then run the vendor setup end to end." },
      { q: "How long until my prop firm can take its first customer?", a: "Typical builds go live in 4–8 weeks: entity and banking first, platform and dashboard in parallel, then payments and payout testing before launch." },
    ],
  },
  {
    slug: "incorporation",
    navLabel: "Incorporation",
    navDesc: "Saint Lucia, BVI, Saint Vincent & Europe",
    iconKey: "file",
    seoTitle: "Company Incorporation for Brokerages — Saint Lucia, BVI, Saint Vincent | Ah-Jin Group",
    seoDesc: "Company incorporation for brokerages and prop firms in Saint Lucia, BVI, Saint Vincent and Europe. Jurisdiction comparison, timelines, required documents — filed end to end.",
    eyebrow: "Company Incorporation for Brokerages",
    buyer: "For founders who need the right entity, in the right place, filed properly",
    h1a: "Incorporate where your",
    h1b: "brokerage can actually operate.",
    outcome: "We form brokerage and prop-firm entities in Saint Lucia, BVI, Saint Vincent and Europe — preparing every document, handling translations and delivering a banking-ready company without the offshore-agent runaround.",
    waMsg: "Hi Ah-Jin Group — I need help with company incorporation.",
    service: "Company Incorporation & Licensing",
    included: [
      { t: "Jurisdiction selection", d: "We match the entity to your client geography, banking needs and licensing plans — not a one-size template." },
      { t: "Full document preparation", d: "Articles, registers, resolutions and KYC packs prepared by us, with translation assistance." },
      { t: "End-to-end filing", d: "We file and follow up directly with registries and agents until certificates are in hand." },
      { t: "Banking-ready output", d: "Corporate documents assembled the way banks and PSPs expect to see them." },
      { t: "Substance guidance", d: "Directors, address and operational substance advice for durable structures." },
      { t: "Upgrade path", d: "Structures designed so a future licence (Seychelles, Mauritius, EU) slots in without a rebuild." },
    ],
    forWho: [
      "Brokerage and prop-firm founders forming a first entity",
      "Operators adding a second jurisdiction",
      "Founders whose bank or PSP rejected weak documents",
      "Teams needing fast, correctly-filed offshore structures",
    ],
    notFor: [
      "Anonymous shell structures with hidden ownership",
      "Tax-evasion driven setups",
      "Personal (non-business) offshore accounts",
    ],
    jurisdictions: [
      { name: "Saint Lucia", note: "IBC in ~1–2 weeks · low cost · the default first base for new brokerages" },
      { name: "BVI", note: "Globally recognised · stronger reputation with counterparties · ~2–3 weeks" },
      { name: "Saint Vincent (SVG)", note: "LLC route, historically popular with FX brands · fast and economical" },
      { name: "Europe", note: "Operating or holding companies where EU presence and banking matter" },
    ],
    proofs: ["capital-investment-sri", "montech-centre-invest", "osher"],
    faqs: [
      { q: "Which jurisdiction is best for a new brokerage?", a: "Saint Lucia is the most common starting point today — fast, affordable and workable with PSPs. BVI suits founders who need stronger counterparty recognition; SVG remains a functional economical route. We recommend based on your banking and client geography, not habit." },
      { q: "What documents do I need to incorporate?", a: "Typically passports, proof of address and a short business description per shareholder/director. We prepare everything else — including certified translations where registries require them." },
      { q: "How long does incorporation take?", a: "Saint Lucia and SVG usually complete within 1–2 weeks; BVI around 2–3 weeks; European entities vary by country. Banking and PSP onboarding afterwards is where most founders lose time — which is exactly what we manage for you." },
      { q: "Does an offshore company mean I don't need a licence?", a: "No — it means your obligations depend on where your clients are and how you market. We advise on the compliant route and, when a licence is needed, run that process too." },
    ],
  },
  {
    slug: "licensing",
    navLabel: "Licensing Support",
    navDesc: "Seychelles, Mauritius, FSCA, UAE & Europe",
    iconKey: "scale",
    seoTitle: "Financial Licensing Support — Seychelles, Mauritius, FSCA, UAE | Ah-Jin Group",
    seoDesc: "Financial licensing support for brokerages: Seychelles SD licence, Mauritius, South Africa FSCA, UAE and Europe. Licence files built, regulator questions anticipated, delays avoided.",
    eyebrow: "Financial Licensing Support",
    buyer: "For operators who need a regulated licence — without regulator ping-pong",
    h1a: "Get licensed without",
    h1b: "losing a year to the process.",
    outcome: "We build complete licence application files, anticipate the regulator's questions before they ask them, and manage the process across Seychelles, Mauritius, South Africa, the UAE and Europe — so approvals arrive without avoidable delays.",
    waMsg: "Hi Ah-Jin Group — I need financial licensing support.",
    service: "Company Incorporation & Licensing",
    included: [
      { t: "Licence strategy", d: "Which licence, where, and whether you need one at all — mapped to your clients and products." },
      { t: "Application file build", d: "Business plans, manuals, financial projections and fit-and-proper packs prepared end to end." },
      { t: "Regulator dialogue", d: "We manage queries and follow-ups so responses are fast, consistent and complete." },
      { t: "Local requirements", d: "Resident directors, compliance officers and local substance arranged via our partner network." },
      { t: "AML / compliance frameworks", d: "AML manuals, MLRO arrangements and reporting set up via partner firms." },
      { t: "Post-licence setup", d: "Banking, platform and operational conditions satisfied so the licence becomes a working business." },
    ],
    forWho: [
      "Brokerages upgrading from an unlicensed offshore structure",
      "Founders targeting regions that require local authorisation",
      "Operators who had an application stall or get rejected",
      "Firms needing ongoing AML / MLRO support after approval",
    ],
    notFor: [
      "Banking, custody or e-money licence projects",
      "Founders looking to \"rent\" someone else's licence",
      "Applications with unverifiable source of funds",
    ],
    jurisdictions: [
      { name: "Seychelles", note: "Securities Dealer licence — the most popular retail FX route today" },
      { name: "Mauritius", note: "Investment Dealer licence · stronger banking access · GBC structure" },
      { name: "South Africa", note: "FSCA FSP licence — credible African regulator, ODP rules apply to CFDs" },
      { name: "UAE", note: "Free-zone and onshore paths depending on activity" },
      { name: "Europe", note: "EU authorisation routes for established operators" },
    ],
    proofs: ["aurum-fx", "fintrion-fx"],
    faqs: [
      { q: "Who actually needs a financial licence?", a: "If you hold client funds, market actively into regulated countries, or your PSPs and liquidity providers require it — you need one. Many early-stage firms legitimately operate offshore first; we tell you honestly which side of the line you're on." },
      { q: "How long does a Seychelles Securities Dealer licence take?", a: "A well-prepared file typically completes in around 4–8 months including capital and local appointments. Poorly prepared applications take far longer — most delays come from incomplete files and slow query responses, which is what we eliminate." },
      { q: "What are the most common causes of delay?", a: "Missing fit-and-proper documentation, weak business plans, unresponsive applicants during regulator queries, and banking not being ready when the regulator asks for proof of capital. Our file-first approach addresses each before submission." },
      { q: "What does licensing support cost?", a: "Incorporation and licensing engagements start from $6,500, with ongoing AML / compliance retainers from $3,500–$4,500 per month depending on scope. Government and capital requirements are separate and disclosed upfront." },
    ],
  },
  {
    slug: "platform-setup",
    navLabel: "Platform Setup",
    navDesc: "MT4 / MT5, cTrader & Match-Trader",
    iconKey: "cpu",
    seoTitle: "Trading Platform Setup — MT4, MT5, cTrader, Match-Trader | Ah-Jin Group",
    seoDesc: "Trading platform setup for brokerages and prop firms: MT4, MT5, cTrader and Match-Trader selection, vendor negotiation, liquidity and CRM integrations, launch support.",
    eyebrow: "Trading Platform Setup",
    buyer: "For founders choosing and deploying their trading technology",
    h1a: "The right platform,",
    h1b: "negotiated, integrated, live.",
    outcome: "MT4, MT5, cTrader or Match-Trader — we help you choose the platform that fits your model, negotiate vendor terms on your behalf and coordinate liquidity, CRM and payment integrations through to a supported launch.",
    waMsg: "Hi Ah-Jin Group — I need help with trading platform setup.",
    service: "Trading Platform Providers",
    included: [
      { t: "Platform selection", d: "A vendor-neutral comparison of MT4/MT5, cTrader and Match-Trader against your model and budget." },
      { t: "Vendor negotiation", d: "Licence fees, white-label terms and SLAs negotiated with providers we work with constantly." },
      { t: "Server & white-label setup", d: "Platform provisioning and broker-side configuration coordinated with the vendor." },
      { t: "Liquidity & bridge integration", d: "LP selection and bridge/aggregation wiring (Centroid, FX-EDGE and others)." },
      { t: "CRM & back-office", d: "FXBO or vendor CRM connected: onboarding, KYC, IB trees and payment flows." },
      { t: "Launch support", d: "Group setup, spreads/swaps configuration assistance and go-live testing with your team." },
    ],
    forWho: [
      "New brokerages choosing their first platform",
      "Prop firms needing challenge-ready technology",
      "Brokers migrating or adding a second platform",
      "Founders who signed a bad vendor deal and want out",
    ],
    notFor: [
      "Retail traders looking for a personal platform",
      "Firms wanting custom platform development from scratch",
      "Projects without a formed (or planned) legal entity",
    ],
    jurisdictions: [
      { name: "Match-Trader", note: "Modern web-first stack, strong prop-firm tooling and CRM" },
      { name: "MetaQuotes MT4 / MT5", note: "The industry standard traders ask for by name" },
      { name: "cTrader", note: "ECN-grade execution, FIX API and transparent depth" },
      { name: "EXO Technologies", note: "CRM & trader-room stack we also support" },
    ],
    proofs: ["capital-flow-trader", "invictus-markets"],
    faqs: [
      { q: "MT5 or Match-Trader — which should I pick?", a: "MT5 wins on trader recognition and ecosystem; Match-Trader wins on speed to launch, integrated CRM and prop features. The right answer depends on your audience and budget — we model both before you sign anything." },
      { q: "Do you replace the platform vendor?", a: "No — vendors perform the core platform configuration. We select them, negotiate your terms, coordinate the integration work around them (liquidity, CRM, payments) and make sure what was promised is what goes live." },
      { q: "How long does a platform setup take?", a: "White-label deployments typically go live in 2–6 weeks depending on the vendor queue and how quickly liquidity and CRM decisions are made. Running these tracks in parallel is where we save you the most time." },
      { q: "Can you help if my current setup is underperforming?", a: "Yes — we audit existing platform, bridge and liquidity arrangements, renegotiate or replace vendors, and manage migrations with minimal trader disruption." },
    ],
  },
  {
    slug: "uae-market-entry",
    navLabel: "UAE & Market Entry",
    navDesc: "UAE base + cross-border operator setup",
    iconKey: "landmark",
    seoTitle: "UAE & Global Market Entry for Brokers and Prop Firms | Ah-Jin Group",
    seoDesc: "UAE market entry for brokerage and prop-firm founders: free-zone setup, banking, substance and cross-border structuring. When the UAE fits — and when it doesn't.",
    eyebrow: "UAE / Global Market Entry",
    buyer: "For founders choosing where to base themselves and their operations",
    h1a: "Base your operation where",
    h1b: "banks and talent say yes.",
    outcome: "The UAE has become the operational home of modern brokerage and prop-firm groups — banking, talent, credibility and tax efficiency in one place. We set up your UAE presence and wire it into your global structure, and we'll tell you plainly when the UAE is not the right fit.",
    waMsg: "Hi Ah-Jin Group — I want to discuss UAE / market entry setup.",
    service: "All-in-One Consultation — Full Launch",
    included: [
      { t: "Free-zone company setup", d: "The right free zone for your activity, with licence category and visas handled." },
      { t: "Banking & PSP onboarding", d: "Corporate accounts opened with documents prepared the way UAE banks expect." },
      { t: "Substance & office", d: "Address, staffing and substance arrangements that satisfy banks and counterparties." },
      { t: "Cross-border structure", d: "UAE hub connected correctly to your offshore or licensed operating entities." },
      { t: "Residency & visas", d: "Founder and key-staff residency coordinated as part of the setup." },
      { t: "Local network", d: "Introductions to the providers, counsel and operators we work with in the region." },
    ],
    forWho: [
      "Brokerage groups wanting a credible operational HQ",
      "Prop-firm founders relocating to a tax-efficient base",
      "LATAM / European operators expanding into MENA",
      "Founders whose home banking has become hostile",
    ],
    notFor: [
      "Businesses that never intend to have real UAE presence",
      "Founders expecting a UAE company alone to equal a licence",
      "Passive paper structures without operations",
    ],
    jurisdictions: [
      { name: "UAE Free Zones", note: "Fast setup, 0% corporate tax regimes for qualifying income, full ownership" },
      { name: "UAE Mainland", note: "For onshore contracts and certain regulated activities" },
      { name: "DIFC / ADGM", note: "Financial-centre paths for regulated activity — when your scale justifies it" },
      { name: "Global pairing", note: "UAE hub + Saint Lucia / Seychelles operating entities — the common modern stack" },
    ],
    proofs: ["invictus-markets", "fintrion-fx"],
    faqs: [
      { q: "Why do brokerage founders choose the UAE?", a: "Banking access, international credibility, deep industry talent, tax efficiency and residency for founders — all in one jurisdiction. Most of the industry's operators now run group functions from the UAE, and we are based here ourselves." },
      { q: "When is the UAE the wrong choice?", a: "If you have no intention of real presence, if your entire market is domestic elsewhere, or if your budget doesn't support proper substance — a lighter offshore-only structure serves you better. We'll tell you which applies before you spend." },
      { q: "Does a UAE company let me operate a brokerage?", a: "A standard free-zone company is your operational and holding base — not a brokerage licence. Regulated activity needs either an offshore/foreign licence structure or a DIFC/ADGM authorisation. We design the combination that fits." },
      { q: "How long does UAE setup take?", a: "Free-zone incorporation typically completes in 1–3 weeks; banking is the long pole at 2–8 weeks depending on the bank and file quality. Our banking-ready document packs are built to shorten exactly that step." },
    ],
  },
];

export const getSolution = (slug, lang = "en") => {
  const base = SOLUTIONS.find((s) => s.slug === slug);
  if (base && lang === "es" && SOLUTIONS_ES[slug]) return { ...base, ...SOLUTIONS_ES[slug] };
  return base;
};

export const getProofs = (ids, lang = "en") =>
  ids
    .map((id) => {
      const base = PROOFS[id];
      if (!base) return null;
      return lang === "es" && PROOFS_ES[id] ? { ...base, ...PROOFS_ES[id] } : base;
    })
    .filter(Boolean);

/* Client proof cards reused across solution pages */
export const PROOFS = {
  "capital-investment-sri": {
    name: "Capital Investment SRI",
    url: "https://www.capitalinvestmentsri.com",
    scope: "Saint Lucia incorporation",
    line: "Ah-Jin took the Saint Lucia incorporation off our plate — structure shaped, every document prepared, operational without the usual offshore noise.",
  },
  "newera-prop": {
    name: "NewEra Prop",
    url: "https://neweraprop.com",
    scope: "Prop-firm launch",
    line: "From paperwork to platform, Ah-Jin took us all the way to launch — challenge model, technology stack and provider integrations end to end.",
  },
  "newera-broker": {
    name: "NewEra Broker",
    url: "https://newera-broker.com",
    scope: "Brokerage launch",
    line: "We came in with a vision for the brokerage and left with a live business — corporate set-up, trading-platform deployment and every provider conversation handled.",
  },
  "montech-centre-invest": {
    name: "Montech Centre Invest",
    url: "https://montechcenterinvest.com/",
    scope: "Incorporation & investment advisory",
    line: "Ah-Jin shaped the structure, engineered the operating model and put the framework into motion with rare clarity.",
  },
  "capital-flow-trader": {
    name: "Capital Flow Trader",
    url: "https://capitalflowtrader.com",
    scope: "Trading-platform launch",
    line: "From day-one company set-up to a fully live trading platform — their provider selection and hands-on onboarding saved us months of trial and error.",
  },
  "aurum-fx": {
    name: "Aurum FX",
    url: "https://www.theaurumfx.com",
    scope: "Seychelles licensing",
    line: "The Seychelles licensing process can be opaque — Ah-Jin made it linear. File built, regulator questions anticipated, licence received without avoidable delay.",
  },
  "invictus-markets": {
    name: "Invictus Markets",
    url: "https://invictus-markets.com",
    scope: "Saint Lucia · incorporation",
    line: "Ah-Jin handled our Saint Lucia incorporation — quick, fast and with zero friction. Exactly the help we needed to get the company stood up.",
  },
  "fintrion-fx": {
    name: "Fintrion FX",
    url: "https://www.fintrionfx.com",
    scope: "Incorporation · South Africa FSCA · set-ups",
    line: "Incorporation handled, the South African regulatory side shaped, and the rest of the operational set-ups stood up — like having an in-house team.",
  },
  osher: {
    name: "Osher",
    url: "https://www.osherltd.com",
    scope: "Incorporation · MT5 launch in progress",
    line: "Ah-Jin handled our incorporation from first document to final certificate — clean, fast and bank-ready. Now they're guiding our MT5 and provider go-live.",
  },
};
